import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';

const ConditionalOrderRoute = ({ children }) => {
  const { user, loading: authLoading } = useAuth();
  const [publicAccess, setPublicAccess] = useState(true); // Default to true
  const [settingsLoading, setSettingsLoading] = useState(true);

  const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

  useEffect(() => {
    const fetchPublicAccessSetting = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/store-settings`);
        const isPublic = response.data?.orders?.publicAccess !== false; // Default to true if not set
        setPublicAccess(isPublic);
      } catch (error) {
        console.error('Error fetching store settings:', error);
        // On error, default to public access (fail open)
        setPublicAccess(true);
      } finally {
        setSettingsLoading(false);
      }
    };

    fetchPublicAccessSetting();
  }, [API_BASE_URL]);

  // Show loading spinner while checking settings and auth
  if (authLoading || settingsLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 mx-auto"></div>
          <p className="text-gray-500 mt-4">Loading...</p>
        </div>
      </div>
    );
  }

  // If public access is enabled, allow anyone
  if (publicAccess) {
    return children;
  }

  // If public access is disabled, require authentication
  if (!user) {
    return <Navigate to="/" replace />;
  }

  // User is authenticated, allow access
  return children;
};

export default ConditionalOrderRoute;
